<template>
    <div class="app-wrapper">
        <div class="main-container">
            <nav-bar></nav-bar>
            <app-main></app-main>
            <buttom-bar></buttom-bar>

        </div>
    </div>
</template>

<script>
    import { NavBar, AppMain, ButtomBar } from './components';

    export default {
        name: 'layout',
        components: {
            ButtomBar,
            NavBar,
            AppMain,
        },
    };
</script>

<style lang="less" scoped>
    .app-wrapper {
        position: relative;
        height: 100%;
        width: 100%;
        &:after {
            content: '';
            display: table;
            clear: both;
        }
    }

    .main-container {
        //min-height: 98vh;
        //background-color: #f0f2f5;
    }
</style>



// WEBPACK FOOTER //
// src/layouts/HeaderLayout/index.vue